export namespace SliderModels {
  export interface Slider {
    background: string
    elements: PPTElement[]
  }

  type LineStyleType = 'solid' | 'dashed' | 'dotted'

  export enum ShapePathFormulasKeys {
    ROUND_RECT = 'roundRect',
    ROUND_RECT_DIAGONAL = 'roundRectDiagonal',
    ROUND_RECT_SINGLE = 'roundRectSingle',
    ROUND_RECT_SAMESIDE = 'roundRectSameSide',
    CUT_RECT_DIAGONAL = 'cutRectDiagonal',
    CUT_RECT_SINGLE = 'cutRectSingle',
    CUT_RECT_SAMESIDE = 'cutRectSameSide',
    CUT_ROUND_RECT = 'cutRoundRect',
    MESSAGE = 'message',
    ROUND_MESSAGE = 'roundMessage',
    L = 'L',
    RING_RECT = 'ringRect',
    PLUS = 'plus',
    TRIANGLE = 'triangle',
    PARALLELOGRAM_LEFT = 'parallelogramLeft',
    PARALLELOGRAM_RIGHT = 'parallelogramRight',
    TRAPEZOID = 'trapezoid',
    BULLET = 'bullet',
    INDICATOR = 'indicator',
  }

  /**
   * 渐变
   *
   * type: 渐变类型（径向、线性）
   *
   * colors: 渐变颜色列表（pos: 百分比位置；color: 颜色）
   *
   * rotate: 渐变角度（线性渐变）
   */
  export type GradientType = 'linear' | 'radial'
  export type GradientColor = {
    pos: number
    color: string
  }
  export interface Gradient {
    type: GradientType
    colors: GradientColor[]
    rotate: number
  }

  export type LinePoint = '' | 'arrow' | 'dot'

  export interface PPTElementOutline {
    style?: LineStyleType
    width?: number
    color?: string
  }

  interface PPTBaseElement {
    // id: string
    x: number
    y: number
    // lock?: boolean
    // groupId?: string
    width: number
    height: number
    rotate?: number
    // link?: PPTElementLink
    // name?: string
  }

  export interface PPTTextElement extends PPTBaseElement {
    type: 'text'
    content: string
    // defaultFontName: string
    // defaultColor: string
    // outline?: PPTElementOutline
    fill?: string
    // lineHeight?: number
    // wordSpace?: number
    // opacity?: number
    // shadow?: PPTElementShadow
    // paragraphSpace?: number
    // vertical?: boolean
    // textType?: TextType
  }

  export interface PPTImageElement extends PPTBaseElement {
    type: 'image'
    // fixedRatio: boolean
    src: string
    outline?: PPTElementOutline
    // filters?: ImageElementFilters
    // clip?: ImageElementClip
    // flipH?: boolean
    // flipV?: boolean
    // shadow?: PPTElementShadow
    radius?: number
    // colorMask?: string
    // imageType?: ImageType
  }

  export interface PPTShapeElement extends PPTBaseElement {
    type: 'shape'
    viewBox: [number, number]
    path: string
    fixedRatio: boolean
    fill: string
    gradient?: Gradient
    pattern?: string
    outline?: PPTElementOutline
    opacity?: number
    flipH?: boolean
    flipV?: boolean
    // shadow?: PPTElementShadow
    special?: boolean
    // text?: ShapeText
    pathFormula?: ShapePathFormulasKeys
    keypoints?: number[]
  }

  export interface PPTLineElement extends Omit<PPTBaseElement, 'height' | 'rotate'> {
    type: 'line'
    start: [number, number]
    end: [number, number]
    style: LineStyleType
    color: string
    points: [LinePoint, LinePoint]
    // shadow?: PPTElementShadow
    broken?: [number, number]
    broken2?: [number, number]
    curve?: [number, number]
    cubic?: [[number, number], [number, number]]
    /** 自定义字段 */
    // source?:string
  }

  export interface PPTVideoElement extends PPTBaseElement {
    type: 'video'
    src: string
    autoplay: boolean
    poster?: string
    ext?: string
  }

  export type PPTElement =
    | PPTTextElement
    | PPTImageElement
    | PPTShapeElement
    | PPTLineElement
    // | PPTChartElement
    // | PPTTableElement
    // | PPTLatexElement
    | PPTVideoElement
  // | PPTAudioElement
}
